import { useState, useMemo } from "react";
import { useToast } from "../../../components/notificaciones/ToastProvider";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Button, Uploader } from "rsuite";
import 'rsuite/Uploader/styles/index.css';
import { Modal } from "react-bootstrap";
import {axiosInstance} from "../../../components/helpers/axiosInstance";

/**
 *
 * @param archivosAD
 * @param setArchivosAD
 * @param idTask
 * @returns {JSX.Element}
 * @constructor
 */
export default function ArchivosAdjuntos({
    archivosAD,
    setArchivosAD,
    idTask
}){
    const [idToDelete, setIdToDelete] = useState(null);
    const toast = useToast();
    const [fileList, setFileList] = useState([]);
    const [showDeleteFile, setShowDeleteFile] = useState(false);
    const [progress, setProgress] = useState(0);
    const [idProgress, setIdProgress] = useState(null);
    dayjs.extend(relativeTime);

    const allFiles = useMemo(() => {
        const array = [];
        fileList.forEach((f) => {
            const reader = new FileReader();
            reader.onload = () => {
                array.push({
                    filename: f?.name,
                    filetype: f?.blobFile.type,
                    content: reader?.result.replace('data:', '').replace(/^.+,/, '')
                })
            }
            reader.readAsDataURL(f.blobFile);
        })

        return array;
    },[fileList]);

    function downloadFile(id){
        axiosInstance.get('/todo/archivos/',{ params : { id_archivo: id },
            onDownloadProgress : (progressEvent) => {
                const porcentaje = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setProgress(porcentaje);
                setIdProgress(id);
            }
         })
            .then((res) => {
                 const link = document.createElement('a');
                 link.href = res.request.responseURL;
                 link.click();
                 document.body.appendChild(link);
                 link.remove();
            })
            .catch((err) => console.error(err));
    }


    function deleteFile(){
        axiosInstance.delete('/todo/archivos/',{data : { id_archivo : idToDelete}})
            .then((res) => {
                toast.setArrayToast(
                    prevState => [
                        ...prevState,
                        {
                            id : idToDelete,
                            text: res.data.result,
                            color: 'success',
                            show: true
                        }
                    ]
                );
                setShowDeleteFile(false);
                setArchivosAD(archivosAD.filter((f) => f.id_archivo !== idToDelete));
            })
            .catch((err) => {
                toast.setArrayToast(
                    prevState => [
                        ...prevState,
                        {
                            id : idToDelete,
                            text: 'Hay un error' + err.data,
                            color: 'danger',
                            show: true
                        }
                    ]
                );
            });
    }

    function addFiles(){
            axiosInstance.post('/todo/archivos/', {
                id_tarea : idTask,
                archivos: allFiles
            }).then((res) => {
                if (res.status === 200){
                    setFileList([]);
                    toast.setArrayToast(
                        prevState => [
                            ...prevState,
                            {
                                id : idTask,
                                text : res.data.result,
                                color : 'success',
                                show : true
                            }
                        ]
                    )
                }
            }).catch((err) => {
                toast.setArrayToast(
                    prevState => [
                        ...prevState,
                        {
                            id : idTask,
                            text : 'Hay un error' + err.data,
                            color: 'danger',
                            show : true
                        }
                    ]
                );
            })
    }

    function fileType(type){
        switch (type) {
            case "application/pdf":
                return "bi bi-filetype-pdf text-danger";
            case "text/plain":
                return "bi bi-filetype-txt text-primary";
            case "image/png":
                return "bi bi-filetype-png text-warning";
            default :
                return "bi bi-filetype-doc text-success";

        }
    }

    return (
        <>
        <div className={'row g-6 g-xl-9 mb-6 mb-xl-9 mt-2'}>
            {
                /**
                 * @param a
                 * @param a.id_archivo
                 * @param a.tipo_mime
                 * @param a.fecha_subida
                 */
                archivosAD && archivosAD.map((a) => {
                    return (
                        <div key={a.id_archivo} className="col-md-6 col-lg-4 col-xl-3">
                            <div className="card h-100">
                                <div
                                    className="card-body d-flex justify-content-center text-center flex-column p-8">
                                    <button type={'button'}
                                            className="btn text-gray-800 text-hover-primary d-flex flex-column"
                                            onClick={() => downloadFile(a.id_archivo)}>
                                        <div className="symbol symbol-60px mb-5">
                                            <i className={fileType(a.tipo_mime)}
                                               style={{fontSize: "5rem"}}></i>
                                        </div>
                                        <div className="fs-5 fw-bold mb-2" style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap"
                                        }}>{a.nombre_archivo}</div>
                                    </button>
                                    {
                                        (progress === 100 && idProgress === a.id_archivo) &&
                                        <i className="bi bi-check2-circle text-success fs-3"></i>
                                    }
                                    <div className={'d-flex justify-content-between align-items-center'}>
                                        <div className="fs-7 fw-semibold text-gray-500 text-capitalize">{dayjs(a.fecha_subida).fromNow()}</div>
                                        <button className={"btn btn-icon btn-bg-light btn-active-color-primary btn-sm"}
                                                type={"button"}
                                                onClick={() => {
                                                    setShowDeleteFile(true);
                                                    setIdToDelete(a.id_archivo);
                                                }}>
                                            <i className="bi bi-trash-fill fs-4 text-primary"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                        ;
                })
            }
            <div className="col-md-6 col-lg-4 col-xl-3">
                <Uploader action={''} fileList={fileList} onChange={setFileList} autoUpload={false} multiple={true}>
                    <div>
                        <div
                            className="card h-100 flex-center bg-light-primary border-primary border border-dashed p-8">
                            <i className="bi bi-file-earmark-arrow-up text-primary" style={{fontSize: '5rem'}}></i>
                            <button className={"btn text-hover-primary fs-5 fw-bold mb-2"} type={'button'}>
                                Agregar archivo
                            </button>
                            <div className="fs-7 fw-semibold text-gray-500">Selecciona archivo</div>
                        </div>
                    </div>
                </Uploader>
                {
                    fileList && fileList.length > 0 &&
                    <button className={"btn btn-outline btn-outline-primary btn-active-light-primary me-8"}
                            type={"button"}
                            onClick={addFiles}><i className="bi bi-cloud-arrow-up-fill fs-2 text-primary"></i> Guardar
                    </button>
                }
            </div>
            </div>
            <Modal show={showDeleteFile} onHide={() => setShowDeleteFile(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Eliminar archivo</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Seguro que quieres eliminar el archivo?</Modal.Body>
                <Modal.Footer>
                    <Button type={'button'} variant="secondary" onClick={() => setShowDeleteFile(false)}>
                        Cancelar
                    </Button>
                    <Button type={'button'} className={"btn btn-outline btn-outline-primary btn-active-light-primary me-8"}
                            onClick={deleteFile}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
